import styled from 'styled-components';

export const VideoOverwrite = styled('div')`
  ${({ theme, isPaused, isEnded }) => `
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: ${theme.colors.black};
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 2;
        &:hover {
            a[title="Download"],
            .close-video {
                opacity: 1;
                visibility: visible;
            }
        }
        ${
          isPaused || isEnded
            ? `
            a[title="Download"],
            .close-video {
                opacity: 1;
                visibility: visible;
            }
            `
            : ''
        }
    `}
`;

export const CloseVideo = styled('div')`
  ${({ theme }) => `
        position: absolute;
        top: ${theme.spacing.px20};
        right: ${theme.spacing.px20};
        cursor: pointer;
        width: ${theme.spacing.px30};
        height: ${theme.spacing.px30};
        background: ${theme.colors.white};
        border-radius: ${theme.rounded.full};
        border: 1px solid ${theme.colors.blueGrey3};
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 0;
        z-index: 3;
        svg {
            font-size: ${theme.fontSize.px20};
            color: ${theme.colors.blueGrey3};
        }
    `}
`;

export const LinkDownload = styled('a')`
  ${({ theme }) => `
        position: absolute;
        bottom: ${theme.spacing.px20};
        right: ${theme.spacing.px15};
        background: rgba(0, 0, 0, 0.85);;
        border-radius: ${theme.rounded.full};
        width: ${theme.spacing.px25};
        height: ${theme.spacing.px25};
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 3;
        opacity: 0;
        visibility: hidden;
        transition: all 0.3s;
        svg {
            font-size: ${theme.fontSize.px16};
            color: ${theme.colors.white};
        }
    `}
`;
